module.exports = __webpack_public_path__ + "static/media/flame.332be8c2.svg";